import React from 'react';
const IconArrowLineLeft = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M8 6H6V18H8V6ZM13.82 12L18.41 16.59L17 18L11 12L17 6L18.41 7.41L13.82 12Z" fill="#666666"/>
</svg>
);
};
export default IconArrowLineLeft;